import React from "react";

export const Checkbox = ({
  id = "id-checkbox",
  name = "name-checkbox",
  callback = (e) => e,
  register = (e) => console.log(e),
  children,
  ...props
}) => {
  const onChange = (e) => {
    callback(e.target.checked);
  };

  return (
    <div className="flex items-center gap-3 custom-control custom-checkbox">
      <input
        type="checkbox"
        id={id}
        name={name}
        className="custom-control-input checkbox-input"
        onChange={onChange}
        {...props}
        {...register(name)}
      />
      <label htmlFor={id} className="text-text-sm text-text-light custom-control-label">
        {children}
      </label>
    </div>
  );
};
